import React, { useState } from 'react';
import TicketCard from './TicketCard';
import TicketDetailsModal from './TicketDetailsModal';
import { useTicketActions } from '@/hooks/useTicketActions';
import { supabase } from '@/integrations/supabase/client';
import { Loader2 } from 'lucide-react';

interface TicketsListProps {
  tickets: any[] | undefined;
  isLoading: boolean;
  onActionComplete?: () => void;
}

const TicketsList: React.FC<TicketsListProps> = ({
  tickets,
  isLoading,
  onActionComplete,
}) => {
  const [selectedTicket, setSelectedTicket] = useState<any>(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  
  const { updateTicketStatus } = useTicketActions();

  const handleStatusChange = async (ticketId: string, newStatus: string) => {
    const { data: { user } } = await supabase.auth.getUser();

    updateTicketStatus.mutate(
      {
        ticketId,
        newStatus,
        adminId: user?.id,
      },
      {
        onSuccess: () => {
          onActionComplete?.();
        },
      }
    );
  };

  const handleViewDetails = (ticket: any) => {
    setSelectedTicket(ticket);
    setShowDetailsModal(true);
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!tickets || tickets.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">Nenhum ticket pendente.</p>
      </div>
    );
  }

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {tickets.map((ticket) => (
          <TicketCard
            key={ticket.id}
            ticket={ticket}
            onStatusChange={handleStatusChange}
            onViewDetails={handleViewDetails}
            isLoading={updateTicketStatus.isPending}
          />
        ))}
      </div>

      <TicketDetailsModal
        isOpen={showDetailsModal}
        onClose={() => {
          setShowDetailsModal(false);
          setSelectedTicket(null);
        }}
        ticket={selectedTicket}
      />
    </>
  );
};

export default TicketsList;
